import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { apiErrorMessage } from '../core/api-error';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import {
  ContactSource,
  CreateContactSourceRequest,
  UpdateContactSourceRequest,
} from '../models';

@Injectable({ providedIn: 'root' })
export class AdminContactSourcesApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).crmApiBaseUrl}/api/admin/BackofficeContactSources`;

  getContactSources(options?: { isActive?: boolean }) {
    let params = new HttpParams();

    if (options?.isActive !== null && options?.isActive !== undefined) {
      params = params.append('isActive', options.isActive);
    }

    return this.httpClient.get<ContactSource[]>(`${this.baseUrl}`, {
      params,
    });
  }

  createContactSource(dto: CreateContactSourceRequest) {
    return this.httpClient.post<{ id: string }>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists: 'Esiste già una fonte con questo nome e dettaglio.',
          }),
        ),
      ),
    );
  }

  updateContactSource(dto: UpdateContactSourceRequest) {
    return this.httpClient.put<void>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            AlreadyExists: 'Esiste già una fonte con questo nome e dettaglio.',
            NotFound: 'La fonte non esiste più.',
          }),
        ),
      ),
    );
  }

  deleteContactSource(id: string) {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(
            error,
            {
              Generic:
                'Impossibile eliminare la fonte: è usata da almeno un contatto. Disattivala invece.',
              NotFound: 'La fonte non esiste più.',
            },
            "Impossibile eliminare la fonte. Riprova più tardi o contatta l'assistenza tecnica.",
          ),
        ),
      ),
    );
  }
}
